/**
 * 带到自动配菜页的待处理数据：勾选菜品或历史菜单修改
 * 内存优先，sessionStorage 作刷新兜底
 */
const STORAGE_KEY = 'foodtoge_pending_menu'

let memoryPending = null

function toPlainDishes(dishes) {
  return (dishes || []).map((d) => ({
    id: String(d.id || ''),
    name: String(d.name || ''),
    price: Number(d.price),
    cost: Number(d.cost),
    category: d.category
  }))
}

function toPlainForm(form) {
  if (!form) return null
  return {
    orderDate: form.orderDate || '',
    roomName: form.roomName || '',
    guestCount: form.guestCount === 0 || form.guestCount ? String(form.guestCount) : '',
    perCapita: form.perCapita === 0 || form.perCapita ? String(form.perCapita) : '',
    profitRatePercent: form.profitRatePercent === 0 || form.profitRatePercent
      ? String(form.profitRatePercent)
      : '',
    needWei: form.needWei === true
  }
}

export function setPendingMenu(dishes, form) {
  const payload = {
    dishes: toPlainDishes(dishes),
    form: toPlainForm(form)
  }
  memoryPending = payload
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  } catch (e) {
    // ignore
  }
}

export function takePendingMenu() {
  const fromMem = memoryPending
  memoryPending = null
  if (fromMem) {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY)
    } catch (e) {
      // ignore
    }
    return {
      dishes: Array.isArray(fromMem.dishes) ? fromMem.dishes : [],
      form: fromMem.form || null
    }
  }
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    window.sessionStorage.removeItem(STORAGE_KEY)
    if (!raw) return { dishes: [], form: null }
    const parsed = JSON.parse(raw)
    if (Array.isArray(parsed)) {
      return { dishes: parsed, form: null }
    }
    return {
      dishes: Array.isArray(parsed.dishes) ? parsed.dishes : [],
      form: parsed.form || null
    }
  } catch (e) {
    return { dishes: [], form: null }
  }
}
